// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".main[data-v-2404a1c5]{border-radius:1000px;font-size:20px;padding:5px 10px;position:relative}.closeBtn[data-v-2404a1c5]{align-items:center;background-color:#5e5ea1;border-radius:50%;cursor:pointer;display:flex;height:24px;justify-content:center;position:absolute;right:-10px;top:-10px;width:24px}.closeImg[data-v-2404a1c5]{height:10px;width:10px}@media screen and (max-width:700px){.main[data-v-2404a1c5]{font-size:small}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
